import CardCategory from "../components/CardCategory";
import IconEvent from "../assets/showevent.svg";
import IconPodcast from "../assets/podcast.svg";
import IconLivestream from "../assets/livestream.svg";
import IconImage from "../assets/image.svg";
import IconVeranstaltungen from "../assets/veranstaltungen.svg";

export default function FilmWrapper() {
  const images = [
    { image: IconEvent, title: "eventfilm-icon" },
    { image: IconImage, title: "imagefilm-icon" },
    { image: IconPodcast, title: "podcast-icon" },
    { image: IconLivestream, title: "livestream-icon" },
    { image: IconVeranstaltungen, title: "veranstaltungen-icon" },
  ];

  const cards = [
    {
      titel: "Showevent",
      image: images[0].image
    },
    {
      titel: "Image",
      image: images[1].image
    },
    {
      titel: "Livestream",
      image: images[3].image
    },
    {
      titel: "Veranstaltungen",
      image: images[4].image
    },
    {
      titel: "Podcast",
      image: images[2].image
    }
  ];

  return (
    <div className="category-wrapper">
      {cards.map((card, index) => (
        <CardCategory
          key={index} // Add a unique key for each card
          titel={card.titel}
          image={card.image}
        />
      ))}
    </div>
  );
}